import React from 'react';
import KanbanSignalBadge from './KanbanSignalBadge';
import {
  formatKanbanInterviewLine,
  formatKanbanDeadlineLine,
  resolveKanbanCardSignals,
} from '../../utils/kanbanCardSignals';

function InfoRow({ label, value, signal, valueClassName = '' }) {
  return (
    <div className="grid grid-cols-[3.25rem_1fr] gap-x-1.5 gap-y-0 items-start text-[10px] leading-snug">
      <span className="text-prodia-text-secondary pt-px">{label}</span>
      <div className="flex flex-wrap items-center gap-1 min-w-0">
        <span className={`text-prodia-text-primary tabular-nums break-words ${valueClassName}`}>{value}</span>
        {signal && <KanbanSignalBadge label={signal.label} variant={signal.variant} />}
      </div>
    </div>
  );
}

export function useKanbanCardSignals(record) {
  const status = record.status;
  const interviewDate = record.interview_date;
  const deadlineValue = record.response_deadline ?? record.decision_date ?? '';

  const signals = resolveKanbanCardSignals({ status, interviewDate, deadlineValue });
  const interviewLine = formatKanbanInterviewLine(interviewDate, record.interview_time);
  const deadlineLine = formatKanbanDeadlineLine(deadlineValue);
  const interviewSignal = signals.interviewUrgency || signals.undecided;

  return { signals, interviewLine, deadlineLine, interviewSignal, deadlineSignal: signals.deadlineUrgency };
}

export default function KanbanCardInfoRows({
  interviewLine,
  deadlineLine,
  startMonthLabel,
  interviewSignal,
  deadlineSignal,
}) {
  return (
    <div className="mt-1.5 pl-2.5 space-y-1">
      <InfoRow label="面談" value={interviewLine} signal={interviewSignal} />
      <InfoRow label="回答期限" value={deadlineLine} signal={deadlineSignal} />
      <InfoRow label="開始月" value={startMonthLabel} />
    </div>
  );
}

export function KanbanTerminalInfoRows({ statusDateLabel, statusDateLine, startMonthLabel }) {
  return (
    <div className="mt-1.5 pl-2.5 space-y-1">
      <InfoRow label={statusDateLabel} value={statusDateLine} />
      <InfoRow label="開始月" value={startMonthLabel} />
    </div>
  );
}

export function isTerminalKanbanColumn(columnId) {
  return columnId === 'won' || columnId === 'lost' || columnId === 'declined';
}
